import FormattedMessage from 'I18n/components/FormattedMessage';
import { canEditObjectPermissions, canWrite } from 'documents-ui/lib/permissions';
import SalesContentPartitioning from 'sales-content-partitioning';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
const ShareHoverButton = ({
  searchResult: {
    contentId,
    contentType,
    userId
  },
  buttonProps
}) => {
  if (!userId || !canWrite() || !canEditObjectPermissions(userId)) {
    return null;
  }
  return /*#__PURE__*/_jsx(Button, Object.assign({
    onClick: () => {
      if (contentId && userId) {
        SalesContentPartitioning.openAssignmentPanel({
          objectId: contentId,
          objectType: contentType,
          ownerId: userId
        });
      }
    }
  }, buttonProps, {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "table.hoverButtons.share"
    })
  }));
};
export default ShareHoverButton;